import action from 'satcheljs/lib/legacy/action';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import getTableToItemRelationKey from 'mini-mail-list-store/lib/utils/getTableToItemRelationKey';
import type Item from 'owa-service/lib/contract/Item';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import type TableViewItemRelation from 'mini-mail-list-store/lib/store/schema/TableViewItemRelation';
import { getConversationOrItemIdFromRow } from '../../utils/getConversationOrItemIdFromRow';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { partialUpdateItem } from './partialUpdateItem';
import { prepareMeetingDataForItemAndGetShouldShowRSVP } from 'mini-mail-list-rsvp/lib/utils/prepareMeetingDataForItemAndGetShouldShowRSVP';

export const addOrUpdateItemData = action('addOrUpdateItemData')(function addOrUpdateItemData(
    rowData: Item,
    tableView: TableView
): void {
    const mailStore = getMailStore();
    const listViewStore = getListViewStore();

    const itemId = rowData.ItemId.Id;

    const shouldShowRSVPForRow = prepareMeetingDataForItemAndGetShouldShowRSVP(rowData, tableView);

    if (mailStore.items.has(itemId)) {
        // If the item is in the cache, partial update it with the new properties
        const itemInCache = mailStore.items.get(itemId);
        partialUpdateItem(itemInCache, rowData, tableView);
    } else {
        initializeClientItem(rowData, shouldShowRSVPForRow);
        mailStore.items.set(itemId, rowData);
    }

    const tableItemRelationKey = getTableToItemRelationKey(
        getConversationOrItemIdFromRow(rowData),
        tableView.id
    );
    const newRelation = {
        clientId: { Id: itemId },
        instanceKey: rowData.InstanceKey,
    } as TableViewItemRelation;
    listViewStore.tableViewItemRelations.set(tableItemRelationKey, newRelation);
});

const initializeClientItem = (clientRowData: ClientItem, shouldShowRSVPForRow: boolean) => {
    clientRowData.shouldShowRSVP = shouldShowRSVPForRow;
    clientRowData.rsvpUnitAriaDetails = '';
};
